export default "__VITE_ASSET__CzbTpkyz__"